import NEISInput from '@/components/common/input/NEISInput'
import type { GradeCode } from '@/api/model/userType'

interface SchoolStepProps {
  schoolName: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSelect: (schoolName: string, schoolCode: string | null) => void
  grade: GradeCode | null
}

// 학년에 따른 학교 타입 매핑
const getSchoolTypeFilter = (grade: GradeCode | null): string | undefined => {
  if (!grade) return undefined

  if (['g1', 'g2', 'g3', 'g4', 'g5', 'g6'].includes(grade)) {
    return '초등학교'
  } else if (['g7', 'g8', 'g9'].includes(grade)) {
    return '중학교'
  } else if (['g10', 'g11', 'g12'].includes(grade)) {
    return '고등학교'
  }

  return undefined
}

export function SchoolStep({ schoolName,  onChange, onSelect, grade }: SchoolStepProps) {
  const schoolTypeFilter = getSchoolTypeFilter(grade)

  return (
    <div className='space-y-4'>
      <div className='space-y-2 mb-6 text-center'>
        <h2 className='text-[24px] font-[700] text-[#020202]'>
          알려줘서 너무 고마워!
          <br />
          어디에서 공부하고
          <br />
          있는지도 궁금해!
        </h2>
        <p className='text-[14px] text-[#7D7D7D]'>(선택사항)</p>
      </div>
      <NEISInput
        placeholder='학교명'
        value={schoolName ?? ''}
        onChange={newValue => {
          // onChange prop은 React.ChangeEvent<HTMLInputElement>를 기대하므로 이벤트 객체를 생성
          const syntheticEvent = {
            target: { value: newValue }
          } as React.ChangeEvent<HTMLInputElement>
          onChange(syntheticEvent)
        }}
        onSelect={school => {
          // 학교 선택 시 학교명을 onSelect로 전달
          onSelect(school.school_name, school.school_code ?? null)
        }}
        inputClassName='w-full pl-6 pr-6 py-3 rounded-2xl bg-white/70 backdrop-blur-sm border-2 border-[#FFA236]/20 focus:border-[#FFA236] focus:outline-none focus:ring-2 focus:ring-[#FFA236]/50 transition-all duration-300 text-center text-[18px] font-[500]'
        schoolTypeFilter={schoolTypeFilter}
      />
    </div>
  )
}
